export interface ICongressSession {
  chamber: string
  endDate?: null | string
  number: number
  startDate: string
  type: string
}
